module.exports = __webpack_public_path__ + "img/logo.19886d1a.svg";